var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "login", staticClass: "login-page" },
    [
      _vm.success == false
        ? _c(
            "van-row",
            [
              _c("van-col", { attrs: { span: "20", offset: "2" } }, [
                _c(
                  "div",
                  { staticClass: "vant-main" },
                  [
                    _c(
                      "van-cell-group",
                      { staticClass: "van-hairline--bottom" },
                      [
                        _c("van-field", {
                          attrs: {
                            "left-icon": "contact",
                            placeholder: "请输入登录账号",
                            autocompleted: "false"
                          },
                          model: {
                            value: _vm.loginForm.username,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "username", $$v)
                            },
                            expression: "loginForm.username"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "van-cell-group",
                      [
                        _c("van-field", {
                          attrs: {
                            type: "password",
                            "left-icon": "bag-o",
                            placeholder: "请输入登录密码",
                            autocompleted: "false"
                          },
                          model: {
                            value: _vm.loginForm.password,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "password", $$v)
                            },
                            expression: "loginForm.password"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "van-cell-group",
                      { style: { marginTop: ".5rem" } },
                      [
                        _c(
                          "van-button",
                          {
                            staticClass: "login-btn",
                            attrs: {
                              type: "info",
                              loading: _vm.loading,
                              "loading-text": "绑定中...",
                              size: "small",
                              block: ""
                            },
                            on: { click: _vm.handleSubmit }
                          },
                          [_vm._v("立即绑定")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _c(
            "van-row",
            { staticClass: "vant-main" },
            [
              _c("van-icon", { attrs: { name: "success", color: "#5daf34" } }),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "恭喜您已成功绑定微信，此微信将作为您账号佣金提现的唯一微信，若要更换微信，请在PC后台解绑后，重新进行微信绑定"
                )
              ])
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a23a9bc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a23a9bc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wxbind.vue
// module id = null
// module chunks = 